import React, { Component } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

class AchievementsBlock extends Component {

  render() {

    let { title, awards } = this.props

    return (
      <section className='achievements-block'>
        <div className='achievements-block__inner'>
          <div className='achievements-block__content'>

          { title && 
            <div className='achievements-block__heading'>
              <h4>{ title }</h4>
            </div>
          }

          { awards  &&

            <div className='achievements-block__items'>

              {awards.map((el, i) => (
                <div className='achievements-block__item' key={i}>
                  { !el.image && <span>{el.text}</span> }
                  { el.image?.sourceUrl && <img src={el.image?.sourceUrl} alt={el.text} /> }
                </div>
               ))}

            </div>
          }

          </div>
        </div>
      </section>
    )
  }
}

export default AchievementsBlock
